import React from 'react';
import { observer } from 'mobx-react';
import { Option, OptionWrapper } from 'libs/forms/styles';
import styled from 'styled-components';

export const PhaseOption = observer(
  ({ app, highlighted, onClick, onMouseOver, scrollRef }) => (
    <PhaseOptionWrapper
      highlighted={highlighted}
      onMouseOver={onMouseOver}
      onClick={onClick}
      ref={scrollRef}
    >
      <Option highlighted={highlighted}>{app.name}</Option>
    </PhaseOptionWrapper>
  ),
);

const PhaseOptionWrapper = styled(OptionWrapper)`
  &:hover {
    > p > a {
      opacity: 1;
    }
  }
`;
